import { createFileRoute } from '@tanstack/react-router'

import { ReadOnlyScope } from '@/components/base'
import { InternalProjectOverview } from '@/components/Internal/Projects/InternalProjectOverview'
import { useProjectDetail } from '@/components/Internal/Projects/project-detail-context'

export const Route = createFileRoute('/internal/projects/$id/overview')({
  component: ProjectOverviewScreen,
})

function ProjectOverviewScreen() {
  // The project's own facts — its status, its customer, its object data.
  const { canChange } = useProjectDetail()

  return (
    <ReadOnlyScope readOnly={!canChange}>
      <InternalProjectOverview />
    </ReadOnlyScope>
  )
}
